<template>
  <div class="modal filter-modal promt-create-modal offer-modal accept-offer">
    <div class="overlay" @click="$parent.closeAcceptOfferModal"></div>
    <div class="wrapper">
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="top">
                <div class="title title-24">
                  <b>{{ $t("Payment detail") }}</b>
                </div>
              </div>
              <div class="bottom">
                <div class="desc">
                  {{ $t("Please enter your bank details to accept payment") }}
                </div>
                <input
                  type="text"
                  v-model="iban"
                  :placeholder="$t('Bank account number')"
                />
                <input
                  type="text"
                  v-model="name"
                  :placeholder="$t('Full name')"
                />
              </div>
              <transition name="slide">
                <div v-if="$parent.error" class="error-desc desc red">
                  {{ $parent.error }}
                </div>
              </transition>
              <div class="buttons">
                <button class="button" @click="$parent.closeAcceptOfferModal">
                  <span>{{ $t("CANCEL") }}</span>
                </button>
                <button class="button blue" @click="confirm">
                  <span>{{ $t("Confirm") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AcceptOfferModal",
  props: [],
  components: {},
  data: function () {
    return {
      name: "",
      iban: "",
    };
  },
  mounted() {},
  methods: {
    confirm() {
      let data = {
        id: this.$parent.activeOffer,
        iban: this.iban,
        full_name: this.name,
      };
      this.$http
        .post(process.env.VUE_APP_API + "offer/approve", data)
        .then(() => {
          this.$parent.closeAcceptOfferModal();
          this.$parent.closeOfferModal();
          this.$parent.openDealModal();
          this.$parent.getCreatedHistory();
        })
        .catch((res) => {
          if (res.response.data.errors) {
            const firstErrors = {};
            for (const key in res.response.data.errors) {
              if (
                res.response.data.errors.hasOwnProperty(key) &&
                Array.isArray(res.response.data.errors[key]) &&
                res.response.data.errors[key].length > 0
              ) {
                firstErrors[key] = res.response.data.errors[key][0];
                this.$emit("setError", firstErrors[key]);
              }
            }
          } else {
            this.$emit("setError", res.response.data.message);
          }
        });
    },
  },
};
</script>
